import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  apiBaseUrl = environment.apiBaseUrl;

  constructor(
    private _httpClient: HttpClient,
  ) { }

  AddChat(query:any,data: any) {
    return this._httpClient.post(`${this.apiBaseUrl}/chats${query}`, data);
  }

  getNotifications(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/notifications${query}`);
  }

  getUnReadNotifications() {
    return this._httpClient.get(`${this.apiBaseUrl}/notifications/unreadCount`);
  }

  addNotification(data: any) {
    return this._httpClient.post(`${this.apiBaseUrl}/notifications`, data);
  }

  getChatData(id: string) {
    return this._httpClient.post(`${this.apiBaseUrl}/chats/create?customerId=${id}`,{});
  }

  getCustomers() {
    return this._httpClient.get(`${this.apiBaseUrl}/customers`);
  }


}
